import classnames from 'classnames'
import { Text } from 'marketing-site/src/library/elements/Text'
import { VisuallyHidden } from 'marketing-site/src/library/elements/VisuallyHidden'
import { HeadingStyle } from 'marketing-site/src/library/utils'
import React from 'react'
import { ISingleHeading } from './index'

export function SingleHeading(props: ISingleHeading): React.ReactElement {
  const { heading, style } = props

  const spanClass = classnames({
    'heading-large': style === HeadingStyle.Large,
    'heading-small': style === HeadingStyle.Small,
    'heading-tiny': style === HeadingStyle.Tiny,
  })

  const getHeadingTextSize = (style: HeadingStyle) => {
    switch (style) {
      case HeadingStyle.Tiny:
        return 'body'

      case HeadingStyle.Small:
        return 'heading-3'

      case HeadingStyle.Large:
      default:
        return 'heading-2'
    }
  }

  return style === HeadingStyle.Hidden ? (
    <VisuallyHidden>
      <span>{heading}</span>
    </VisuallyHidden>
  ) : (
    <span className={spanClass}>
      <Text size={getHeadingTextSize(style)} brand="default">
        {heading}
      </Text>
      <style jsx>
        {`
          .heading-large {
            margin: 0 0 32px 0;
            display: block;
          }

          .heading-small {
            margin: 0 0 36px 0;
            font-weight: normal;
            display: block;
          }

          .heading-tiny {
            margin: 0 0 12px 0;
            display: block;
            line-clamp: 2;
          }
        `}
      </style>
    </span>
  )
}
